const styles = () => ({
  heading: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#002E47',
  },
  headingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  disabledHint: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#838D98',
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginTop: -4,
    marginBottom: 8,
  },
  infoText: {
    color: 'var(--Color---Dark, #637381)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '22px',
  },
  infoLink: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '22px',
    verticalAlign: 'baseline',
  },
})

export default styles
